export default __webpack_public_path__ + "static/hero-illustration-7c67f3db799f4fbb84e8a5bb1b104595.svg";